import Field from './Field';

Field.install = function(Vue) {
    Vue.component(Field.name, Field);
};

export default Field;